import type { OrderDetail } from 'pages/orders/models';
import React from 'react';

interface OwnProps {
  order: OrderDetail;
  showFormNumber?: boolean;
  customFormCodeNumber: number;
}

const OrderCodeBlock = (props: OwnProps) => {
  const { order, showFormNumber, customFormCodeNumber } = props;

  const orderCode = showFormNumber ? `${order.code} - ${customFormCodeNumber}` : order.code;

  return <div className="OrderCodeBlock">{orderCode}</div>;
};

export default OrderCodeBlock;
